import { createSlice } from "redux-starter-kit";
import {
  getMeFetchSuccess,
  getMeFetch,
  getMeFetchCancel,
  getMeFetchRejected,
} from "./logicActions";
import UserInfo from "./UserInfo";
import { LoadingState } from "../http";

export interface UserState {
  user: UserInfo | {};
  loadingState: LoadingState;
}

const initialState: UserState = {
  user: {},
  loadingState: LoadingState.LOADING,
};

const user = createSlice({
  initialState,
  slice: "user",
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: {
    [getMeFetch.toString()]: (state) => {
      state.loadingState = LoadingState.LOADING;
    },
    [getMeFetchCancel.toString()]: (state) => {
      state.loadingState = LoadingState.NO_DATA;
    },
    [getMeFetchRejected.toString()]: (state) => {
      state.loadingState = LoadingState.REJECTED;
    },
    [getMeFetchSuccess.toString()]: (state, action) => {
      state.loadingState = LoadingState.RESOLVED;
      if (action.payload) {
        state.user = action.payload;
      }
    },
  },
});

export default user;
